module.exports = __webpack_public_path__ + "img/rus.c3e686d0.svg";